import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import moment from 'moment';
import MainAppRouter from './app';
import { store } from './store';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './app/ErrorBoundary';
import './index.css';
import { Toaster } from './app/components/Toaster';

moment.updateLocale('en', {
  week: { dow: 1 },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <Provider store={store}>
    <ErrorBoundary>
      <Toaster />
      <MainAppRouter />
    </ErrorBoundary>
  </Provider>,
);

reportWebVitals();
